<template>
    <div>
        <ul>
            <aside-menu-item
                v-for="(item, index) in showMenu"
                :key="index"
                :item="item"
                :is-submenu-list="isSubmenuList"
                :is-aside-mobile="isAsideMobile"
                :show-submenu-info="showSubmenuInfo"
                :class="{'bottom-0 w-full pr-2' : item.label === 'お問い合わせ'}"
                :is-go-spo-plus-home="!item.icon && !item.img"
                class="p-2"
                @menu-click="menuClick"
            />
        </ul>
    </div>
</template>

<script>
import AsideMenuItem from '@/spComponents/Utilities/AsideMenuItem'
import { computed } from 'vue'
import { useStore } from 'vuex'

export default {
    name: 'AsideMenuList',
    components: {
        AsideMenuItem,
    },
    props: {
        isSubmenuList: {
            type: Boolean,
            default: false
        },
        menu: {
            type: Array,
            default: () => []
        },
        isAsideMobile: {
            type: Boolean,
            default: false
        },
        showSubmenuInfo: {
            type: Object,
            default: () => {}
        },
    },
    emits: ['menu-click', 'toggle-sidebar'],
    setup (props, { emit }) {
        console.log(props.menu)
        const store = useStore()

        const showMenu = computed(() => {
            if (!store.getters.inTeam) {
                return props.menu.filter(m => !m.showOnlyInTeam)
            }
            return props.menu
        })
        const menuClick = (event, item) => {
            emit('menu-click', event, item)
        }

        const toggleSidebar = () => {
            emit('toggle-sidebar')
        }

        return {
            menuClick,
            showMenu,
            toggleSidebar
        }
    }
}
</script>
